
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/math",
      function () {
        return require("private-next-pages/math/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/math"])
      });
    }
  